import { Component, Input, OnInit } from '@angular/core';
import { ADDONS, ADDONS_MAP } from '../../metadata';
import { Addons } from '../../models';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-special-marks-full',
  templateUrl: './special-marks-full.component.html',
  styleUrls: ['./special-marks-full.component.scss'],
})
export class SpecialMarksFullComponent implements OnInit {
  @Input() public addons: Addons;
  public readonly ADDONS_MAP = ADDONS_MAP;
  public truthyAddons: Partial<Addons>;

  constructor(private readonly translateService: TranslateService) {}
  public ngOnInit() {
    this.truthyAddons = ADDONS.reduce((result, addon) => {
      if (this.addons[addon.value]) {
        if (
          addon.value === 'time_of_delivery' &&
          this.addons[addon.value].type
        ) {
          switch (this.addons[addon.value].type) {
            case 'level1': {
              result[addon.value] = `${this.translateService.instant(
                'DELIVERY.DELIVERY_TITLE'
              )}
             ${this.translateService.instant('DELIVERY.LEVEL1').toLowerCase()}`;
              break;
            }
            case 'level2': {
              result[addon.value] = `${this.translateService.instant(
                'DELIVERY.DELIVERY_TITLE'
              )}
            ${this.translateService.instant('DELIVERY.LEVEL2').toLowerCase()}`;
              break;
            }
            case 'level3': {
              result[addon.value] = `${this.translateService.instant(
                'DELIVERY.DELIVERY_TITLE'
              )}
            ${this.translateService.instant('DELIVERY.LEVEL3').toLowerCase()}`;
              break;
            }
            case 'level4': {
              result[addon.value] = `${this.translateService.instant(
                'DELIVERY.DELIVERY_TITLE'
              )}
            ${this.translateService
              .instant('BATCH_MAILING.BATCHES_TAB.EMS.FROM')
              .toLowerCase()}
            ${this.addons[addon.value].time_interval.from}
            ${this.translateService
              .instant('BATCH_MAILING.BATCHES_TAB.EMS.TO')
              .toLowerCase()}
            ${this.addons[addon.value].time_interval.to}`;
              break;
            }
          }
        } else {
          result[addon.value] = this.addons[addon.value];
        }
      }
      return result;
    }, {});
  }

  public isObjectEmpty(object: any): boolean {
    return object && Object.keys(object).length === 0;
  }
}
